import { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";
import PageTitle from "components/text/PageTitle";
import MailingListListContainer from "./MailingListListContainer";
import RoundActionIcon from "components/buttons/RoundActionIcon";
import ButtonPrimaryIcon from "components/buttons/ButtonPrimaryIcon";
import SectionTitle from "components/text/SectionTitle";

import returnIcon from "assets/img/icons/return-icon.svg";
import plusIcon from "assets/img/icons/plus-sign.svg";
import plusWhiteIcon from "assets/img/icons/plus-sign-white.svg";
import emailBookIcon from "assets/img/icons/icons8-address-book.svg";

const MailingLists = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BackIconWrap = styled.div``;

const ButtonWrap = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
`;

const ManageLeadsBox = styled.div`
  position: relative;
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const BoxTitle = styled.div`
  width: 100%;

  line-height: 130%;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};
`;

const TitleIcon = styled.div`
  display: inline-block;
  padding-right: 6px;

  transform: translateY(4.5px);

  width: 28px;
  min-width: 28px;
`;

const Text = styled.div`
  line-height: 130%;
`;

export default () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const from = searchParams.get("from") ? searchParams.get("from") : null;
  const autoresponderId = searchParams.get("responder-id")
    ? searchParams.get("responder-id")
    : null;

  // set page Title
  useEffect(() => {
    document.title = "Mailing Lists | Scalelup";
  }, []);

  let returnTo = "/marketing-tools";

  if (from === "autoresponder") {
    if (autoresponderId) {
      returnTo = `/autoresponder?id=${autoresponderId}`;
    }
  }

  return (
    <Layout>
      <MailingLists>
        <Header>
          <PageTitle>Mailing Lists</PageTitle>
          <BackIconWrap>
            <RoundActionIcon
              icon={returnIcon}
              iconSize="16px"
              iconAlt="Return"
              onClick={() => navigate(returnTo)}
            />
          </BackIconWrap>
        </Header>
        <ManageLeadsBox>
          <TopContent>
            <Heading>
              <BoxTitle>
                <TitleIcon>
                  <img src={emailBookIcon} style={{ width: "100%" }} />
                </TitleIcon>
                Manage Your Leads
              </BoxTitle>
              <Text>
                Mailing lists store the contacts you have collected through your
                landing pages. Contact new leads as soon as possible and start
                working with them while they are still interested in your offer.
              </Text>
            </Heading>
          </TopContent>
        </ManageLeadsBox>
        <SectionTitle>Lists</SectionTitle>
        <MailingListListContainer />
        <ButtonWrap>
          <ButtonPrimaryIcon
            icon={plusIcon}
            iconHover={plusWhiteIcon}
            onClick={() => {
              navigate("/create-mailing-list");
            }}
          >
            Create Mailing List
          </ButtonPrimaryIcon>
        </ButtonWrap>
      </MailingLists>
    </Layout>
  );
};
